import auth from '@api/auth'
import getErrorMessage from '@utils/getErrorMessage';

import {
  ACTIVATION_BEGIN,
  ACTIVATION_CLEAR,
  ACTIVATION_FAILURE,
  ACTIVATION_SUCCESS,
  REGISTRATION_BEGIN,
  REGISTRATION_CLEAR,
  REGISTRATION_FAILURE,
  REGISTRATION_SUCCESS,
} from './_types'

const getDefaultState = () => {
  return {
    activationCompleted: false,
    activationError: false,
    activationLoading: false,
    activationResponseMessage: '',
    registrationCompleted: false,
    registrationError: false,
    registrationLoading: false,
    registrationErrorMessage: '',
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  [ACTIVATION_BEGIN](state) {
    state.activationLoading = true
  },
  [ACTIVATION_CLEAR](state) {
    state.activationCompleted = false
    state.activationError = false
    state.activationLoading = false
    state.activationResponseMessage = ''
  },
  [ACTIVATION_FAILURE](state, message) {
    state.activationError = true
    state.activationLoading = false
    state.activationResponseMessage = message
  },
  [ACTIVATION_SUCCESS](state, message) {
    state.activationCompleted = true
    state.activationError = false
    state.activationLoading = false
    state.activationResponseMessage = message
  },
  [REGISTRATION_BEGIN](state) {
    state.registrationLoading = true
  },
  [REGISTRATION_CLEAR](state) {
    Object.assign(state, getDefaultState())
  },
  [REGISTRATION_FAILURE](state, errorMessage) {
    state.registrationErrorMessage = errorMessage
    state.registrationError = true
    state.registrationLoading = false
  },
  [REGISTRATION_SUCCESS](state) {
    state.registrationCompleted = true
    state.registrationError = false
    state.registrationLoading = false
  },
}

export const actions = {
  createAccount({ commit, dispatch }, { username, password1, password2, email, recaptchaToken }) {
    commit(REGISTRATION_BEGIN)

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    return (
      auth
        .createAccount(username, password1, password2, email, recaptchaToken, timezone)
        .then((response) => {
          commit(REGISTRATION_SUCCESS)
          const token = response.data.key
          commit('auth/SET_TOKEN', token, { root: true })
        })
        .catch((error) => {
          const errorMessage = getErrorMessage(error);
          commit(REGISTRATION_FAILURE, errorMessage)
        })
    )
  },
  activateAccount({ commit }, key) {
    commit(ACTIVATION_BEGIN)
    return auth
      .verifyAccountEmail(key)
      .then((response) => {
        commit(ACTIVATION_SUCCESS, response.data.message)
      })
      .catch((error) => {
        const errorMessage = getErrorMessage(error);
        commit(ACTIVATION_FAILURE, errorMessage)
      })
  },
  clearRegistrationStatus({ commit }) {
    commit(REGISTRATION_CLEAR)
  },
  clearActivationStatus({ commit }) {
    commit(ACTIVATION_CLEAR)
  },
}
